import { gql } from "@apollo/client";

// Direct-to-S3 upload flow. Operation names equal the field names on purpose: errorLink in
// Services/ClientConfig.ts matches them against UPLOAD_OPERATION_NAMES to suppress Logout().

export const ENSURE_QUOTE_FILE_DIRECTORIES = gql`
  mutation ensureQuoteFileDirectories(
    $quoteId: Int!
    $availableForSupplier: Boolean
    $parentId: Int
    $paths: [String!]!
  ) {
    ensureQuoteFileDirectories(
      quoteId: $quoteId
      availableForSupplier: $availableForSupplier
      parentId: $parentId
      paths: $paths
    ) {
      path
      directoryId
    }
  }
`;

export const INIT_QUOTE_FILE_UPLOADS = gql`
  mutation initQuoteFileUploads(
    $quoteId: Int!
    $availableForSupplier: Boolean
    $comment: String
    $files: [quoteFileUploadInput!]!
  ) {
    initQuoteFileUploads(
      quoteId: $quoteId
      availableForSupplier: $availableForSupplier
      comment: $comment
      files: $files
    ) {
      clientRef
      status
      uploadToken
      message
      mode
      key
      contentType
      partSize
      partCount
      urls {
        partNumber
        url
      }
      ttlSeconds
    }
  }
`;

export const SIGN_QUOTE_FILE_UPLOAD_PARTS = gql`
  mutation signQuoteFileUploadParts(
    $uploadToken: String!
    $partNumbers: [Int!]!
  ) {
    signQuoteFileUploadParts(
      uploadToken: $uploadToken
      partNumbers: $partNumbers
    ) {
      partNumber
      url
    }
  }
`;

// No "file" scalar and no quote { id } here: either one makes the server read the object back
// from S3 into memory, once per finalized file.
// restart: the upload session is dead (object gone, size mismatch, INSERT failed); the file has
// to be initialised and uploaded again rather than completed once more.
export const COMPLETE_QUOTE_FILE_UPLOADS = gql`
  mutation completeQuoteFileUploads($uploads: [quoteFileUploadComplete!]!) {
    completeQuoteFileUploads(uploads: $uploads) {
      clientRef
      status
      message
      missingParts
      restart
      file {
        id
        title
        comment
        fileUid
        fileURL
        fileName
        fileSize
        availableForSupplier
        directoryId
        createdAt
        updatedAt
        user {
          id
          userName
        }
      }
    }
  }
`;

export const ABORT_QUOTE_FILE_UPLOADS = gql`
  mutation abortQuoteFileUploads($uploadTokens: [String!]!) {
    abortQuoteFileUploads(uploadTokens: $uploadTokens)
  }
`;
